import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoTransactionAttemptLogListRequest, LogControllerDtoTransactionAttemptLogListResponse,
  PerplayLogApi,
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import {TRANSACTION_ATTEMPT_LOG_LIST_REQUEST} from "../../constants/log/transactionAttemptLogConstants";


const api = new PerplayLogApi(config.API_CLIENT);

function* transactionAttemptLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoTransactionAttemptLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.accountNo = payload.accountNo;
    requestData.walletAddress = payload.walletAddress;
    requestData.status = payload.status;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogTransactionAttemptLogListPost({ logControllerDtoTransactionAttemptLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoTransactionAttemptLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* transactionAttemptLogRootSaga() {
  yield all([
    takeEvery(TRANSACTION_ATTEMPT_LOG_LIST_REQUEST, transactionAttemptLogListRequestSaga),
  ]);
}

const transactionAttemptLogSaga = [
  fork(transactionAttemptLogRootSaga)
];

export default transactionAttemptLogSaga;
